import { forwardRef, createElement } from 'react';

function IconEntryTypeCustomerInvoice(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M7.5 16c2.434 0 3.88 1.316 4.34 3.95A1.75 1.75 0 0110.116 22H4.884a1.75 1.75 0 01-1.724-2.05C3.62 17.315 5.066 16 7.5 16zm.25-12.5a.25.25 0 00-.243.193L7.5 3.75V9.5c-.54 0-1.053.164-1.5.464V3.75C6 2.784 6.784 2 7.75 2h7.525c.464 0 .91.184 1.238.513l3.974 3.974c.329.329.513.774.513 1.238V18.25A1.75 1.75 0 0119.25 20h-6.038l-.01-.063a11.184 11.184 0 00-.369-1.437h6.417a.25.25 0 00.243-.193l.007-.057v-10h-3a1.75 1.75 0 01-1.744-1.606L14.75 6.5v-3h-7zm-.25 7c1.105 0 2 1.12 2 2.5s-.895 2.5-2 2.5-2-1.12-2-2.5.895-2.5 2-2.5zm9.75 3a.75.75 0 110 1.5h-5.5a.75.75 0 110-1.5h5.5zm0-3a.75.75 0 110 1.5h-6a.75.75 0 110-1.5h6zm1.378-3.75L16.25 4.371V6.5a.25.25 0 00.193.243l.057.007h2.128z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var EntryTypeCustomerInvoice = /*#__PURE__*/forwardRef(IconEntryTypeCustomerInvoice);

export default EntryTypeCustomerInvoice;
//# sourceMappingURL=EntryTypeCustomerInvoice.js.map
